import {googleCreateNewEvent, googleUpdateEvent, googleDeleteEvent,
        getAndUpdateGoogleCalendarData,
        convertGoogleEventToGrownupsEvent, convertGrownupsEventToGoogleEvent} from './CalendarProviderGoogle';

// This code is a wrapper, so we can support more providers later (outlook, ical)

export const providerCreateNewEvent = async (event, calendarId='primary') => {
    return await googleCreateNewEvent(event, calendarId);
}

export const providerUpdateEvent = (event) => {
    return googleUpdateEvent(event);
}

export const providerDeleteEvent = (event) => {
    return googleDeleteEvent(event);
}

export const convertProviderEventToGrownupsEvent = (providerEvent) => {
    return convertGoogleEventToGrownupsEvent(providerEvent);
}

export const convertGrownupsEventToProviderEvent = (grownwupsEvent) => {
    return convertGrownupsEventToGoogleEvent(grownwupsEvent);
}

export const getAndUpdateCalendarProvidersData = (accounts, setCalendars, setEvents, setSelectedCalendars, cachedEvents, setCachedEvents, currentDate, onTokenExpired = null) => {
    return getAndUpdateGoogleCalendarData(accounts, setCalendars, setEvents, setSelectedCalendars, cachedEvents, setCachedEvents, currentDate, onTokenExpired);
}
